var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';

import Button from '../button';

var PillCloud = function PillCloud(_ref) {
    var options = _ref.options,
        onSelect = _ref.onSelect,
        _ref$selectedOptions = _ref.selectedOptions,
        selectedOptions = _ref$selectedOptions === undefined ? [] : _ref$selectedOptions,
        _ref$buttonProps = _ref.buttonProps,
        buttonProps = _ref$buttonProps === undefined ? {} : _ref$buttonProps;
    return React.createElement(
        'div',
        { className: 'pill-cloud-container' },
        options && options.map(function (option) {
            return React.createElement(
                Button,
                _extends({
                    className: classNames('pill', 'pill-cloud-button', {
                        'is-selected': selectedOptions.find(function (op) {
                            return isEqual(op, option);
                        })
                    }),
                    key: option.value,
                    onClick: onSelect ? function () {
                        return onSelect(option);
                    } : undefined
                }, buttonProps),
                option.text
            );
        })
    );
};

PillCloud.propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    })).isRequired,
    onSelect: PropTypes.func,
    selectedOptions: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
    })),
    buttonProps: PropTypes.object
};
export default PillCloud;
import PropTypes from 'prop-types';